module.exports = __webpack_public_path__ + "static/media/presentation.2802ffd0.pptx";